exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table-grupos{\r\n    max-height: 251px;\r\n    overflow-y: scroll;\r\n}\r\n\r\n.table-grupos table td input{\r\n    height: 15px;\r\n}\r\n\r\n\r\n#tableResults th, td{\r\n    width: 300px;\r\n    padding-right: 15px;\r\n}\r\n\r\n.resultado-consulta{\r\n    overflow-x: auto\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/ewerton.w.da.silva/Documents/Visual Studio 2017/Projects/SCL_Valia/SCL_Valia/src/app/paginas/relatorios/gerenciar-relatorios/gerenciar-relatorios.component.css
// module id = ../../../../../src/app/paginas/relatorios/gerenciar-relatorios/gerenciar-relatorios.component.css
// module chunks = 1